import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../app/stores/store";

const AirportT3Report = observer(() => {
  const { bookingStore } = useStore();

  useEffect(() => {
    bookingStore.loadAirportCashierBookings();
  }, [bookingStore]);

  return (
    <div className="listing-page max-md:pt-7 mt-[120px] px-4 md:px-8">
      <section className="section booking-listing pt-0">
        <div className="container mx-auto">
          <div className="row">
            <div className="col-lg-12 d-flex">
              <div className="card book-card flex-fill mb-0 p-0">
                <h1 className="text-xl md:text-2xl font-semibold px-4 pt-4">
                  Airport T3 – Sales by Service
                </h1>

                <div className="overflow-x-auto mt-6">
                  <table className="min-w-full bg-white border border-gray-200 shadow-md rounded-lg overflow-hidden text-sm md:text-base">
                    <thead className="bg-blue-600 text-white">
                      <tr>
                        <th className="text-left py-3 px-3 md:px-5">Service</th>
                        <th className="text-left py-3 px-3 md:px-5">Total</th>
                        <th className="text-left py-3 px-3 md:px-5">
                          Total child
                        </th>
                        <th className="text-left py-3 px-3 md:px-5">
                          Total qty
                        </th>
                        <th className="text-left py-3 px-3 md:px-5">
                          No. of Sales
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {bookingStore.salesByService.length ? (
                        bookingStore.salesByService.map((item, index) => (
                          <tr
                            key={index}
                            className="border-b hover:bg-gray-50 transition-all"
                          >
                            <td className="py-2 px-3 md:px-5">
                              {item.serviceName}
                            </td>
                            <td className="py-2 px-3 md:px-5">
                              {item.totalPrice}
                            </td>
                            <td className="py-2 px-3 md:px-5 font-semibold text-gray-800">
                              {item.airportUserChildPrice}
                            </td>
                            <td className="py-2 px-3 md:px-5 font-semibold text-gray-800">
                              {item.totalQty}
                            </td>
                            <td className="py-2 px-3 md:px-5 font-semibold text-gray-800">
                              {item.bookingCount}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan={5}
                            className="text-center py-4 text-gray-500"
                          >
                            No sales found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
});

export default AirportT3Report;
